var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card task-lane-item"},[_c('div',{staticClass:"card-block"},[_c('h5',{staticClass:"card-title"},[_c('span',{staticClass:"text-muted"},[_vm._v("#"+_vm._s(_vm.item.id))]),_vm._v("\n          "+_vm._s(_vm.item.text)+"\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f920eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskLaneItem.vue
// module id = null
// module chunks = 